type Props = {
  children: string;
};

export const PaidServiceLabel = ({ children }: Props) => {
  return (
    <span className="inline-flex items-center font-bold rounded bg-blue-200 text-blue-400 text-xs leading-none px-[0.8rem] py-[0.5rem]">
      {children}
    </span>
  );
};
